import React, { useEffect, useRef, useState } from 'react'
import { Formik, Form, setIn } from 'formik'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  FaCheckDouble,
  FaCommentAlt,
  FaCreditCard,
  FaHandHoldingUsd,
  FaHistory,
  FaPlusCircle,
  FaTrash,
  FaWallet
} from 'react-icons/fa'
import toast from 'react-hot-toast'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'

import DatePicker from '../../../shared/DatePicker'
import SwitchButtons from '../../../shared/SwitchButtons'
import DropdownField from '../../../shared/DropdownField'
import AutoCompleteField from '../../../shared/AutoCompleteField'
import TextInput from '../../../shared/TextInput'
import BillSummary from './BillSummary'
import { fetchData } from '../../../helpers/fetchData'
import SwitchInput from '../../../shared/SwitchInput'
import Spinner from '../../../shared/Spinner'

import {
  cardLabels,
  getCardOptions,
  patientCashPlansOptionsFormat,
  patientDocIdFieldsOptionsFormat,
  patientFileNoFieldsOptionsFormat,
  patientInsuracnePlansOptionsFormat,
  patientMobileFieldsOptionsFormat,
  patientsNameFieldOptionsFormat,
  paymentMethods,
  practionerOptionsFormat,
  visitTypeOptions,
  getFixedCardCost
} from '../../../constants/VisitsConstants'
import {
  createVisitValidationSchema,
  createPayBillAllItemsValidationSchema
} from '../../../validations/VisitsValidations'
import VisitPriceItems from './VisitPriceItems'
import CustomButton from '../../../shared/CustomButton'
import {
  getCashPayersData,
  updateVisitItems
} from '../../../redux/slices/VisitsSlice'
import { getPractitionerList } from '../../../services/ApiMethods'
import CheckPermission from '../../../hooks/CheckPermission'
import {
  calculateCashItemsDetails,
  calculateInsuranceItemsDetails,
  getInsuranceRemainingLimit
} from './VisitItemsCalculations'
import { useTranslation } from 'react-i18next'
import VisitPriceItemsPayBill from './VisitPriceItemsPayBill'
import ApplyDiscountModal from './ApplyDiscountModal'
import PayBillInvoicesModal from './PayBillInvoicesModal'
import { getGroupItemFirst, groupByItemType } from '../../../utils/GroupByItem'
import { priceListTypesOptionsFormatForOrderItems } from '../../../constants/PriceListConstants'
import { handlePrintData } from '../../../utils/PrintData'
import Flag from 'react-world-flags'
import { getCountryCode } from '../../../utils/CountryCodes'
import { RiDiscountPercentLine } from 'react-icons/ri'
import { CalculateAge } from '../../../utils/CalculateAge'
import PatientAlertsDisplay from '../patient-alerts/PatientAlertsDisplay'
import RemMaxLimit from './RemMaxLimit'
import buildUnitPaymentRequest from './buildUnitPaymentRequest'
import {
  buildPayableUnits,
  getOrderedBillItems,
  getUnpaidBillItems,
  groupBillUnits,
  mergeFormItems
} from '../../../utils/payBill'

const PayVisitBillForm = ({
  setSelectedPatient,
  refreshCreditTrigger,
  setOpenPayCreditForm,
  setOpenDepositForm,
  setOpenWithdrawForm,
  showComments,
  setShowComments,
  selectedPatient
}) => {
  const formRef = useRef(null)
  const { state } = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [itemsLoading, setItemsLoading] = useState(false)
  const [invoiceNo, setInvoiceNo] = useState(null)
  const isWithOutSlot = state?.isWithOutSlot || false
  const [openModal, setOpenModal] = useState(false)
  const { hasPermission } = CheckPermission()
  const { cashPayers } = useSelector(state => state?.visits)
  const [billingVisitData, setBillingVisitData] = useState(
    state?.billingVisitData || null
  )
  const [activeIndex, setActiveIndex] = useState(0)
  const isPayBill = state?.isPayBill || false
  const { date, selectedPractitionerId } = state
  const [patientType, setPatientType] = useState(
    billingVisitData?.visit_payment_type || 'cash'
  )
  const [priceListType, setPriceListTypes] = useState([])
  const [selectedPatientData, setSelectedPatientData] = useState(null)
  const [payemntStatus, setPaymentStatus] = useState('paid')
  const currentDateTime = moment().format('DD-MM-YYYY HH:mm')
  const [cardOptions, setCardOptions] = useState([])
  const [depositLoading, setDepositLoading] = useState(false)
  const [depositBalance, setDepositBalance] = useState(0)
  const [creditLoading, setCreditLoading] = useState(false)
  const [creditBalance, setCreditBalance] = useState(0)
  const [openDiscountModal, setOpenDiscountModal] = useState(false)
  const [invoiceDiscount, setInvoiceDiscount] = useState(0)
  const [episodeRemainingLimit, setEpisodeRemainingLimit] = useState(0)
  const [episodeMaxLimit, setEpisodeMaxLimit] = useState(0)
  const [insuranceLimit, setInsuranceLimit] = useState(null)
  const [episodeType, setEpisodeType] = useState('First Visit')
 const currentInvoiceDate = moment().format('YYYY-MM-DDTHH:mm')
  const [patientInsuracnePlans, setPatientInsurancePlans] = useState([])
  const [practitionersList, setPractionersList] = useState([])
  const [selectedPayerData, setSelectedPayerData] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [fieldsLoading, setFieldsLoading] = useState(false)
  const isHasPractitionerPermission = hasPermission('practitioner', 'get')
  const isHaveGetPayerPermission = hasPermission('payer', 'get')
  const { t } = useTranslation()
  const { invoiceSettings } = useSelector(state => state?.auth)
  const isAllItemsMode =
    (invoiceSettings?.paybill_settings?.display_mode || 'category_tabs') ===
    'all_items'
  const [invoicesModalOpen, setInvoicesModalOpen] = useState(false)
  const [paidInvoices, setPaidInvoices] = useState([])

  const initialValues = {
    visitDate: date,
    patientName: billingVisitData?.patient?.full_name || '',
    patientDocumentId: billingVisitData?.patient?.document_id || '',
    patientFileNo: billingVisitData?.patient?.file_no || '',
    patientType:
      billingVisitData?.visit_payment_type ||
      billingVisitData?.patient?.beneficiary_type ||
      '',
    practitioner:
      billingVisitData?.practitioner_id ||
      billingVisitData?.practitionerID ||
      billingVisitData?.practitioner?.practitioner_id ||
      '',
    payerName: getSelectedPayerData() || '',
    speciality: billingVisitData?.practitioner?.speciality?.name_en || '',
    visitType:
      billingVisitData?.visit_type?.type === 'Follow up'
        ? 'Follow Up'
        : billingVisitData?.visit_type?.type || 'Consultation',
    paymentMethod:
      depositBalance > 0
        ? 'Deposit'
        : billingVisitData?.payment_method || 'cash',
    comment: billingVisitData?.comment || '',
    contactNo: billingVisitData?.patient?.contact || '',
    items: isAllItemsMode
      ? getOrderedBillItems(billingVisitData?.items)
      : getGroupItemFirst(billingVisitData),
    paid: payemntStatus,
    cardType: depositBalance > 0 ? '' : 'Mada',
    cards: depositBalance > 0 ? [] : [{ cardType: 'Mada', amount: 0 }],
    deduct_from_deposit: false
  }

  useEffect(() => {
    const practionerdata = practitionersList?.find(
      item =>
        item?.practitioner_id == billingVisitData?.practitioner_id ||
        billingVisitData?.practitioner?.practitioner_id
    )
    if (practionerdata) {
      getCardOptions(setCardOptions, practionerdata)
    }
  }, [
    billingVisitData?.practitioner_id,
    billingVisitData?.practitioner?.practitioner_id,
    practitionersList
  ])

  useEffect(() => {
    handleSetFieldValue('paid', payemntStatus)
  }, [payemntStatus])

  const handleSetFieldValue = (field, value) => {
    const currentValues = formRef?.current?.values || {}
    formRef?.current?.setValues({
      ...currentValues,
      [field]: value
    })
  }

  useEffect(() => {
    if (isHasPractitionerPermission) {
      getPractitionerList(setFieldsLoading, setPractionersList)
    }
  }, [isHasPractitionerPermission])

  useEffect(() => {
    if (isHaveGetPayerPermission && !cashPayers) {
      dispatch(getCashPayersData())
    }
  }, [isHaveGetPayerPermission])

  const handlePatientSelect = (event, formkikProps) => {
    const patientData = event?.value?.patientData
    setSelectedPatientData(patientData)
    setPatientInsurancePlans(patientData?.insurance_plans || [])
    if (
      patientData?.beneficiary_type != 'cash' &&
      patientData?.insurance_plans?.length
    ) {
      setSelectedPayerData(patientData?.insurance_plans[0])
      formkikProps.setFieldValue(
        'payerName',
        patientData?.insurance_plans[0]?.his_payer_id
      )
    } else if (patientData?.beneficiary_type == 'cash') {
      formkikProps.setFieldValue('payerName', cashPayers?.[0]?.payer_id)
      setSelectedPayerData(cashPayers?.[0])
    } else {
      formkikProps.setFieldValue('payerName', '')
      setSelectedPayerData(null)
    }
    setPatientType(patientData?.beneficiary_type)
    formkikProps.setFieldValue('items', [])
    formkikProps.setFieldValue('patientDocumentId', patientData?.document_id)
    formkikProps.setFieldValue('patientFileNo', patientData?.file_no)
    formkikProps.setFieldValue('patientName', patientData?.full_name)
    formkikProps.setFieldValue('patientType', patientData?.beneficiary_type)
    formkikProps.setFieldValue('contactNo', patientData?.contact)
  }

  const handlePatientFieldBlur = (event, props) => {
    let value = event?.target?.value
    if (!value && selectedPatientData) {
      props.setFieldValue('patientName', selectedPatientData?.full_name)
      props.setFieldValue('patientDocumentId', selectedPatientData?.document_id)
      props.setFieldValue('patientFileNo', selectedPatientData?.file_no)
      props.setFieldValue('contactNo', selectedPatientData?.contact)
    }
  }

  useEffect(() => {
    const getVisitById = async () => {
      if (!billingVisitData?.visit_id) return
      setItemsLoading(true)
      try {
        const res = await fetchData('POST', '/v3/visit/getById', {
          visit_id: billingVisitData?.visit_id
        })
        if (res?.data) setBillingVisitData(res.data)
      } catch (err) {
        console.log(err)
      } finally {
        setItemsLoading(false)
      }
    }
    getVisitById()
  }, [])

  const fetchInsuranceLimits = async (visitData = billingVisitData) => {
    if (!visitData?.visit_id) return
    try {
      const res = await fetchData('POST', '/v3/visit/getInsuranceLimits', {
        visit_id: visitData?.visit_id,
        patient_id: visitData?.patient?.patient_id || visitData?.patient_id,
        file_number: visitData?.patient?.file_no,
        document_id: visitData?.patient?.document_id
      })
      if (res?.data) {
        setEpisodeRemainingLimit(res?.data?.episode_remaining_limit || 0)
        setEpisodeMaxLimit(res?.data?.episode_max_limit || 0)
        setInsuranceLimit(
          res?.data?.episode_remaining_limit ?? res?.data?.max_limit ?? null
        )
        setEpisodeType(res?.data?.episode_type || 'First Visit')
      }
    } catch (err) {
      console.error('Failed to fetch insurance limits:', err)
    }
  }

  useEffect(() => {
    fetchInsuranceLimits()
  }, [billingVisitData?.visit_id])

  const refreshBillAfterPayment = async () => {
    const visitId = billingVisitData?.visit_id
    if (!visitId) return

    try {
      const res = await fetchData('POST', '/v3/visit/getById', {
        visit_id: visitId
      })
      const freshVisit = res?.data
      if (!freshVisit) return

      setBillingVisitData(freshVisit)
      await fetchInsuranceLimits(freshVisit)

      // Only the all_items sheet mirrors the bill into the form. The tabbed
      // display keeps exactly its previous behaviour.
      if (isAllItemsMode) {
        const freshItems = getOrderedBillItems(freshVisit?.items).map(item => ({
          ...item,
          checked: item?.checked ?? true
        }))
        formRef?.current?.setFieldValue('items', freshItems)
      }
    } catch (err) {
      // A failed refresh must never break the payment flow or leave the
      // submit spinner stuck - the payment itself has already succeeded.
      console.error('Failed to refresh the bill after payment:', err)
    }
  }

  const handleCloseInvoicesModal = async () => {
    setInvoicesModalOpen(false)
    setPaidInvoices([])
    await refreshBillAfterPayment()
  }

  const getGroupPatientPayable = (groupItems, values) => {
    if (!groupItems?.length) return 0

    const cardCost = getFixedCardCost(cardOptions, values?.cardType)
    const cashItems = groupItems.filter(item => item?.item_category === 'cash')
    const insuranceItems = groupItems.filter(
      item => item?.item_category !== 'cash'
    )

    const cashTotals = cashItems.length
      ? calculateCashItemsDetails(
        {
          ...values,
          items: cashItems,
          document_type: selectedPatientData?.document_type
        },
        cardCost
      )?.totals
      : null

    const insuranceTotals = insuranceItems.length
      ? calculateInsuranceItemsDetails(
        { ...values, items: insuranceItems },
        insuranceLimit ?? getInsuranceRemainingLimit(selectedPayerData),
        selectedPatientData,
        cardCost
      )?.totals
      : null

    return (
      Number(cashTotals?.patientShareTotal || 0) +
      Number(cashTotals?.patientTaxTotal || 0) +
      Number(insuranceTotals?.patientShareTotal || 0) +
      Number(insuranceTotals?.patientTaxTotal || 0)
    )
  }

  const handleMultiTabPay = async values => {
    const currentTime = moment().format('HH:mm')
    const formattedVisitDate = `${values?.visitDate}T${currentTime}`
    const cardCostValue = getFixedCardCost(cardOptions, values?.cardType)

    const payableUnits = buildPayableUnits(
      groupBillUnits(billingVisitData?.items),
      values?.items,
      item => item?.checked
    )

    if (!payableUnits.length) {
      toast.error(t('PleaseCheckedItem'))
      return
    }

    // Every unit payload is built and checked before a single payment is sent,
    // so an input problem can never stop the batch after money has moved.
    const requests = []
    for (const unit of payableUnits) {
      const { billingPayload, creditPayload, totalAmount, netCashPay } =
        buildUnitPaymentRequest({
          t,
          values,
          unitItems: unit.items,
          formattedVisitDate,
          cardCostValue,
          cardOptions,
          selectedPatientData,
          selectedPayerData,
          insuranceLimit,
          billingVisitData,
          currentInvoiceDate
        })

      if (values?.deduct_from_deposit && depositBalance < netCashPay) {
        toast.error(
          t('DepositBalanceInsufficient', { balance: depositBalance.toFixed(2) })
        )
        return
      }

      if (
        values?.paymentMethod === 'multi_payment' &&
        payableUnits.length === 1
      ) {
        const inputCash = Number(values?.cash || 0)
        const inputBank = Number(values?.bank || 0)
        const inputCredit = Number(values?.credit || 0)
        const inputCards =
          values.cards?.reduce(
            (sum, card) => sum + (Number(card.amount) || 0),
            0
          ) || 0
        const totalInput = inputCash + inputBank + inputCredit + inputCards

        if (Math.abs(totalAmount - totalInput) > 0.05) {
          toast.error(
            t('TotalPaymentMustMatch', {
              totalInput: totalInput?.toFixed(2),
              totalAmount
            })
          )
          return
        }
      }

      requests.push({ billingPayload, creditPayload })
    }

    setIsLoading(true)

    try {
      const results = []
      for (const { billingPayload, creditPayload } of requests) {
        try {
          const result = await dispatch(
            updateVisitItems({
              billingPayload,
              navigate,
              creditPayload,
              silent: true
            })
          ).unwrap()

          results.push(result)
        } catch (error) {
          toast.error(error || 'Error')
          return
        }
      }

      const printed = await Promise.allSettled(
        results
          .filter(item => item?.InvoiceNo)
          .map(async item => {
            const response = await fetchData(
              'POST',
              '/v3/invoices/printPatient',
              {
                invoice_number: item?.InvoiceNo,
                file_no: item?.file_no,
                document_id: item?.document_id
              }
            )
            return {
              invoiceNumber: item?.InvoiceNo,
              html: response || '',
              file_no: item?.file_no,
              document_id: item?.document_id
            }
          })
      )

      const invoiceList = printed
        .filter(result => result.status === 'fulfilled')
        .map(result => result.value)

      setPaidInvoices(invoiceList)
      setInvoicesModalOpen(true)
      toast.success(results.find(item => item?.message)?.message || t('Success'))
    } finally {
      setIsLoading(false)
    }
  }

  const handleFormSubmit = async values => {
    if (isAllItemsMode) {
      await handleMultiTabPay(values)
      return
    }

    if (
      !values?.items?.length &&
      (values?.visitType != 'Follow Up' || values?.visitType != 'Follow up')
    ) {
      toast.error(t('At least one item is required'))
      return
    }

    const isSlectedItemFound = values?.items?.some(
      data => data?.checked == true
    )
    if (billingVisitData && !isSlectedItemFound) {
      toast.error(t('PleaseCheckedItem'))
      return
    }
    const currentTime = moment().format('HH:mm')
    const formattedVisitDate = `${values?.visitDate}T${currentTime}`
    const cardCostValue = getFixedCardCost(cardOptions, values?.cardType)

    const { billingPayload, creditPayload, totalAmount, netCashPay } =
      buildUnitPaymentRequest({
        t,
        values,
        unitItems: values?.items,
        formattedVisitDate,
        cardCostValue,
        cardOptions,
        selectedPatientData,
        selectedPayerData,
        insuranceLimit,
        billingVisitData,
        currentInvoiceDate
      })

    if (values?.deduct_from_deposit && depositBalance < netCashPay) {
      return toast.error(
        t('DepositBalanceInsufficient', { balance: depositBalance.toFixed(2) })
      )
    }

    if (
      values?.paymentMethod === 'card' ||
      values?.paymentMethod === 'multi_payment'
    ) {
      if (values?.paymentMethod === 'card') {
        const isValid =
          Array.isArray(cardOptions) &&
          cardOptions.some(
            group =>
              Array.isArray(group.options) &&
              group.options.some(
                opt =>
                  opt.value === values.cardType || opt.label === values.cardType
              )
          )
        if (!values.cardType || !isValid) {
          toast.error(t('Please Select Card Type'))
          return
        }
      } else if (values?.paymentMethod === 'multi_payment') {
        const cardPayments =
          values.cards?.filter(card => Number(card.amount) > 0) || []
        for (const card of cardPayments) {
          const isValid =
            Array.isArray(cardOptions) &&
            cardOptions.some(
              group =>
                Array.isArray(group.options) &&
                group.options.some(
                  opt =>
                    opt.value === card.cardType || opt.label === card.cardType
                )
            )
          if (!card.cardType || !isValid) {
            toast.error(t('Please Select Card Type for all card payments'))
            return
          }
        }
      }
    }

    if (values?.paymentMethod === 'multi_payment') {
      const inputCash = Number(values?.cash || 0)
      const inputBank = Number(values?.bank || 0)
      const inputCredit = Number(values?.credit || 0)
      const inputCards =
        values.cards?.reduce(
          (sum, card) => sum + (Number(card.amount) || 0),
          0
        ) || 0

      const totalInput = inputCash + inputBank + inputCredit + inputCards

      if (Math.abs(totalAmount - totalInput) > 0.05) {
        toast.error(
          t('TotalPaymentMustMatch', {
            totalInput: totalInput?.toFixed(2),
            totalAmount
          })
        )
        return
      }
    }

    setIsLoading(true)

    try {
      const res = await dispatch(
        updateVisitItems({ billingPayload, navigate, creditPayload })
      )

      if (res?.error) {
        return
      }

      if (res?.payload?.PaymentStatus == 'Unpaid') {
        await refreshBillAfterPayment()

        setIsLoading(false)

        if (res?.payload?.InvoiceNo) {
          setOpenModal(true)
          const response = await fetchData(
            'POST',
            '/v3/invoices/printPatient',
            {
              invoice_number: res?.payload?.InvoiceNo,
              file_no: res?.payload?.file_no,
              document_id: res?.payload?.document_id
            }
          )

          response ? setInvoiceNo(response) : setInvoiceNo(null)
          if (response) {
            handlePrintData(response, 'Invoice')
          }
        }
      } else {
        if (navigate && res?.payload?.InvoiceNo) {
          navigate(`/print-invoice/${res?.payload?.InvoiceNo}`, {
            state: {
              state: {
                file_no: res?.payload?.file_no,
                document_id: res?.payload?.document_id
              },
              invoiceNumber: res?.payload?.InvoiceNo,
              navigattion: isWithOutSlot
                ? '/create-visit-without-slot'
                : '/visits'
            }
          })
        } else if (!res?.payload?.InvoiceNo) {
          toast.error('Invoice number not received from server')
        }
      }
    } finally {
      setIsLoading(false)
    }
  }

  const isInitialSetupRef = useRef(false)
  const userSelectedBeneficiaryRef = useRef(null)

  useEffect(() => {
    if (billingVisitData && !isInitialSetupRef.current) {
      let selctedPatient = billingVisitData?.patient
      if (
        billingVisitData?.visit_payment_type != 'cash' &&
        billingVisitData?.patient?.beneficiary_type != 'cash'
      ) {
        const selectedPlanPayerId =
          billingVisitData?.patient?.selected_plan?.his_payer_id ||
          billingVisitData?.patient?.selected_plan?.payer_id
        let payerData =
          billingVisitData?.patient?.insurance_plans?.find(
            data =>
              data?.his_payer_id == selectedPlanPayerId ||
              data?.payer_id == selectedPlanPayerId
          ) || billingVisitData?.patient?.insurance_plans?.[0]
        setPatientInsurancePlans(
          billingVisitData?.patient?.insurance_plans || []
        )

        setSelectedPayerData(payerData)
      } else {
        setSelectedPayerData(cashPayers?.[0])
      }
      setSelectedPatientData(selctedPatient)

      const typeToSet =
        userSelectedBeneficiaryRef.current ||
        billingVisitData?.visit_payment_type ||
        billingVisitData?.patient?.beneficiary_type
      setPatientType(typeToSet)

      setSelectedPatient(billingVisitData?.patient)
      isInitialSetupRef.current = true
    }

    if (
      billingVisitData &&
      isInitialSetupRef.current &&
      userSelectedBeneficiaryRef.current
    ) {
      const currentType = userSelectedBeneficiaryRef.current

      if (currentType == 'cash') {
        setSelectedPayerData(cashPayers?.[0])
        setPatientInsurancePlans([])
        formRef?.current?.setFieldValue('payerName', cashPayers?.[0]?.payer_id)
      } else if (currentType == 'corporate' || currentType == 'government') {
        const insurancePlans = selectedPatientData?.insurance_plans || []
        setPatientInsurancePlans(insurancePlans)
        if (insurancePlans.length > 0 && !formRef?.current?.values?.payerName) {
          setSelectedPayerData(insurancePlans[0])
          formRef?.current?.setFieldValue(
            'payerName',
            insurancePlans[0]?.his_payer_id
          )
        }
      }

      setPatientType(currentType)
      formRef?.current?.setFieldValue('patientType', currentType)

      userSelectedBeneficiaryRef.current = null
    }

    if (billingVisitData) {
      const unpaidItems =
        billingVisitData?.items?.filter(
          item => item?.status?.toLowerCase() == 'unpaid'
        ) || []

      if (isAllItemsMode) {
        formRef?.current?.setFieldValue(
          'items',
          getOrderedBillItems(billingVisitData?.items)
        )
        setActiveIndex(0)
      } else {
        formRef?.current?.setFieldValue(
          'items',
          getGroupItemFirst(
            billingVisitData,
            Object?.values(groupByItemType(unpaidItems))?.length - 1
          )
        )
        setActiveIndex(
          Object?.values(groupByItemType(unpaidItems))?.length - 1
        )
      }
    }
  }, [billingVisitData])

  function getSelectedPayerData() {
    if (
      billingVisitData?.visit_payment_type != 'cash' &&
      billingVisitData?.patient?.beneficiary_type != 'cash'
    ) {
      return (
        billingVisitData?.patient?.selected_plan?.his_payer_id ||
        billingVisitData?.patient?.selected_plan?.payer_id ||
        billingVisitData?.patient?.insurance_plans?.[0]?.his_payer_id
      )
    } else if (
      billingVisitData?.patient?.beneficiary_type == 'cash' ||
      billingVisitData?.visit_payment_type == 'cash'
    ) {
      return cashPayers?.[0]?.payer_id
    }
  }

  useEffect(() => {
    const fetchPatientDeposit = async () => {
      setDepositLoading(true)
      try {
        const res = await fetchData('POST', '/v3/deposit/getdeposit', {
          patient_id: selectedPatientData?.patient_id
        })
        setDepositBalance(res?.balance ?? 0)
        return res
      } catch (err) {
        console.log(err)
      } finally {
        setDepositLoading(false)
      }
    }
    if (selectedPatientData?.patient_id) {
      fetchPatientDeposit()
    }
  }, [billingVisitData])

  useEffect(() => {
    const fetchPatientCredit = async () => {
      setCreditLoading(true)
      try {
        const res = await fetchData(
          'POST',
          '/v3/patient/creditBalance/getByPatientId',
          {
            patient_id: selectedPatientData?.patient_id
          }
        )
        setCreditBalance(res?.data?.patient_credit_amount ?? 0)
        return res
      } catch (err) {
        console.log(err)
      } finally {
        setCreditLoading(false)
      }
    }
    if (selectedPatientData?.patient_id) {
      fetchPatientCredit()
    }
  }, [billingVisitData, refreshCreditTrigger])

  const getPriceListTypes = async () => {
    const response = await fetchData('POST', '/v3/pricelist_types/get', {})
    let formatedData = response?.data
      ? priceListTypesOptionsFormatForOrderItems(response?.data)
      : []
    setPriceListTypes(formatedData)
  }
  useEffect(() => {
    getPriceListTypes()
  }, [])
  const getPatientById = async id => {
    const res = await fetchData('POST', '/v3/patient/getById', {
      patient_id: id
    })
    return res
  }

  return (
    <div className='w-full h-full'>
      <Formik
        innerRef={formRef}
        initialValues={initialValues}
        validationSchema={
          isAllItemsMode
            ? createPayBillAllItemsValidationSchema
            : createVisitValidationSchema
        }
        onSubmit={handleFormSubmit}
      >
        {props => {
          const allUnpaidItems = getUnpaidBillItems(billingVisitData?.items)

          if (typeof window !== 'undefined' && window.__DEBUG_TOTAL_BILL__) {
            console.log('[TotalBill] billingVisitData.items:', billingVisitData?.items)
            console.log('[TotalBill] form values.items:', props?.values?.items)
            console.log('[TotalBill] allUnpaidItems:', allUnpaidItems)
          }

          const allItems = mergeFormItems(allUnpaidItems, props?.values?.items)
            .map(item => ({ ...item, checked: true }))
            .filter(
              item =>
                !item?.is_approval ||
                item?.approval_status?.toLowerCase() === 'approved'
            )

          const allCashItems = allItems.filter(
            item => item?.item_category === 'cash'
          )
          const allInsuranceItems = allItems.filter(
            item => item?.item_category !== 'cash'
          )

          const cashBillTotal = (() => {
            if (!allItems.length) return null

            const isDepositPayment =
              props?.values?.paymentMethod?.toLowerCase() === 'deposit'

            const toDetailsItems = items =>
              isDepositPayment
                ? items.map(item => ({
                  ...item,
                  tax_check: false,
                  payer_vat: false
                }))
                : items

            const cashDetails = allCashItems.length
              ? calculateCashItemsDetails({
                ...(props?.values || {}),
                items: toDetailsItems(allCashItems),
                nationality:
                  selectedPatientData?.nationality ||
                  billingVisitData?.patient?.nationality,
                deduct_from_deposit:
                  props?.values?.deduct_from_deposit || false
              })
              : null

            const insuranceDetails = allInsuranceItems.length
              ? calculateInsuranceItemsDetails(
                {
                  ...(props?.values || {}),
                  items: toDetailsItems(allInsuranceItems)
                },
                insuranceLimit ?? getInsuranceRemainingLimit(selectedPayerData),
                selectedPatientData
              )
              : null

            const cashTotals = cashDetails?.totals || {}
            const insuranceTotals = insuranceDetails?.totals || {}

            const patientNet =
              Number(cashTotals?.patientShareTotal || 0) +
              Number(cashTotals?.patientTaxTotal || 0) +
              Number(insuranceTotals?.patientShareTotal || 0) +
              Number(insuranceTotals?.patientTaxTotal || 0)

            const gross =
              Number(cashTotals?.totalGrossAmount || 0) +
              Number(insuranceTotals?.totalGrossAmount || 0)
            const discount =
              Number(cashTotals?.discountAmountTotal || 0) +
              Number(insuranceTotals?.discountAmountTotal || 0)

            return {
              gross: gross.toFixed(2),
              discount: discount.toFixed(2),
              net: patientNet.toFixed(2),
              total: patientNet.toFixed(2)
            }
          })()

          return (
            <div className='w-full gap-x-3 gap-y-1 mt-2'>
              <div className='w-full mb-2'>
                <div className='flex items-center justify-end gap-1 mb-1'>
                  {patientType === 'insurance' && (
                    <RemMaxLimit
                      remainingMaxLimit={episodeRemainingLimit}
                      maxLimit={episodeMaxLimit}
                    />
                  )}
                  {!isAllItemsMode && cashBillTotal?.total && (
                    <div className='inline-flex items-center gap-2 bg-primary/10 rounded-md px-2.5 sm:px-3 py-1 sm:py-1.5 border border-primary/20'>
                      <span className='text-[10px] sm:text-[11px] font-bold uppercase text-primary'>
                        {t('Total Bill')}
                      </span>
                      <span className='text-[11px] sm:text-xs font-semibold whitespace-nowrap text-primary'>
                        {cashBillTotal?.total}
                      </span>
                    </div>
                  )}
                </div>

                <BillSummary
                  className='w-full'
                  patientType={patientType}
                  formikRef={formRef}
                  selectedPatientData={selectedPatientData}
                  selectedPayerData={selectedPayerData}
                  cardOptions={cardOptions}
                  depositBalance={depositBalance}
                  updateDepositValues={true}
                  invoiceDiscount={invoiceDiscount}
                  followUp={episodeType}
                  episodeRemainingLimit={episodeRemainingLimit}
                  maxLimitOverride={insuranceLimit}
                />
              </div>
              <Form
                className='w-full'
                onKeyDown={e => {
                  if (e.key === 'Enter') {
                    e.preventDefault()
                  }
                }}
              >
                <PatientAlertsDisplay
                  patientId={selectedPatientData?.patient_id}
                />

                <div className='grid grid-cols-12 gap-3'>
                  <div className='col-span-12 lg:col-span-11'>
                    <div className='grid grid-cols-12 gap-3 items-end mb-2'>
                      <div className='col-span-12 lg:col-span-5'>
                        <label className='input-label block mb-1'>
                          {t('PatientType')}
                        </label>
                        <div className='w-full overflow-x-auto scrollbar-hide'>
                          <SwitchButtons
                            isDisabled={patientType == 'insurance'}
                            labels={[
                              { name: t('Cash'), value: 'cash', disabled: false },
                              {
                                name: t('Insurance'),
                                value: 'insurance',
                                disabled: true
                              },
                              {
                                name: t('Corporate'),
                                value: 'corporate',
                                disabled: false
                              },
                              {
                                name: t('Government'),
                                value: 'government',
                                disabled: false
                              }
                            ]}
                            setActiveState={async value => {
                              userSelectedBeneficiaryRef.current = value

                              setPatientType(value)
                              props.setFieldValue('patientType', value)

                              if (value == 'cash') {
                                setSelectedPayerData(cashPayers?.[0])
                                setPatientInsurancePlans([])
                                props.setFieldValue(
                                  'payerName',
                                  cashPayers?.[0]?.payer_id
                                )
                                props.setFieldValue('items', [])
                              } else if (
                                value == 'corporate' ||
                                value == 'government'
                              ) {
                                const res = await getPatientById(
                                  selectedPatientData?.patient_id
                                )
                                if (res?.data) {
                                  setSelectedPatient(res?.data)
                                  setSelectedPatientData(res?.data)
                                  setPatientInsurancePlans(
                                    res?.data?.insurance_plans || []
                                  )
                                  if (res?.data?.insurance_plans?.length > 0) {
                                    setSelectedPayerData(
                                      res?.data?.insurance_plans?.[0]
                                    )
                                    props.setFieldValue(
                                      'payerName',
                                      res?.data?.insurance_plans?.[0]
                                        ?.his_payer_id
                                    )
                                  }
                                  props.setFieldValue('items', [])
                                }
                              }
                            }}
                            activeState={patientType}
                          />
                        </div>
                      </div>
                      <div className='col-span-6 lg:col-span-2'>
                        <div className='flex items-center justify-between gap-2 text-[13px] md:text-[15px] font-bold text-red-800 bg-red-100 px-3 md:px-4 py-2 rounded-lg whitespace-nowrap shadow-sm h-[30px] w-full'>
                          <span className='font-semibold text-[11px] md:text-[14px] uppercase tracking-tight'>
                            {t('C.B')}:
                          </span>
                          <span className='tabular-nums'>
                            {creditBalance?.toFixed(2) || '0.00'}
                          </span>
                        </div>
                      </div>
                      <div className='col-span-6 lg:col-span-2'>
                        <div className='flex items-center justify-between gap-2 text-[13px] md:text-[15px] font-bold text-indigo-800 bg-indigo-100 px-3 md:px-4 py-2 rounded-lg whitespace-nowrap shadow-sm h-[30px] w-full'>
                          <span className='font-semibold text-[11px] md:text-[14px] uppercase tracking-tight'>
                            {t('D.B')}:
                          </span>
                          <span className='tabular-nums'>
                            {depositBalance?.toFixed(2) || '0.00'}
                          </span>
                        </div>
                      </div>
                      <div className='col-span-4 lg:col-span-2'>
                        <div className='flex items-center justify-between gap-2 text-[13px] md:text-[15px] font-bold text-success bg-success/10 px-3 md:px-4 py-2 rounded-lg whitespace-nowrap shadow-sm h-[30px] w-full'>
                          <span className='font-semibold text-[11px] md:text-[14px] tracking-tight'>
                            {t('Age')}:
                          </span>
                          <span className='tabular-nums'>
                            {selectedPatientData
                              ? CalculateAge(selectedPatientData?.dob)
                              : '--'}
                          </span>
                        </div>
                      </div>
                      <div className='col-span-12 lg:col-span-3'>
                        {/* Optional info space */}
                      </div>
                    </div>

                    <div className='w-full grid grid-cols-12 gap-3 '>
                      <AutoCompleteField
                        parentClass='col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4'
                        label={t('SelectPatient')}
                        placeholder={t('SearchPatientByName')}
                        optionsFormat={patientsNameFieldOptionsFormat}
                        onSelect={event => handlePatientSelect(event, props)}
                        name='patientName'
                        fieldUrl='/v3/patient/search'
                        onBlur={event => handlePatientFieldBlur(event, props)}
                        NavigationIcon={() => (
                          <div className='flex gap-2 items-center justify-center cursor-pointer'>
                            {selectedPatientData?.nationality && (
                              <Flag
                                code={getCountryCode(
                                  selectedPatientData?.nationality || 'Saudi'
                                )}
                                fallback={<span>{t('Unknown')}</span>}
                                className='h-4 w-6'
                                title={selectedPatientData?.nationality}
                              />
                            )}
                            <FaPlusCircle
                              size={20}
                              className='text-iconC'
                              onClick={() => navigate('/create-beneficiary')}
                            />
                          </div>
                        )}
                        readOnly
                      />
                      <AutoCompleteField
                        parentClass='col-span-12 md:col-span-6 lg:col-span-2 xl:col-span-2'
                        label={t('PatientDocumentId')}
                        placeholder={t('SearchPatientByDocumentId')}
                        optionsFormat={patientDocIdFieldsOptionsFormat}
                        onSelect={event => handlePatientSelect(event, props)}
                        name='patientDocumentId'
                        fieldUrl='/v3/patient/search'
                        onBlur={event => handlePatientFieldBlur(event, props)}
                        readOnly
                      />
                      <AutoCompleteField
                        parentClass='col-span-12 md:col-span-6 lg:col-span-2 xl:col-span-2'
                        label={t('MRN')}
                        placeholder={t('SearchPatientByMRN')}
                        optionsFormat={patientFileNoFieldsOptionsFormat}
                        onSelect={event => handlePatientSelect(event, props)}
                        name='patientFileNo'
                        fieldUrl='/v3/patient/search'
                        onBlur={event => handlePatientFieldBlur(event, props)}
                        readOnly
                      />
                      <AutoCompleteField
                        parentClass='col-span-12 md:col-span-6 lg:col-span-2 xl:col-span-2'
                        label={t('PatientMobile')}
                        placeholder={t('SearchPatientByMobile')}
                        optionsFormat={patientMobileFieldsOptionsFormat}
                        onSelect={event => handlePatientSelect(event, props)}
                        name='contactNo'
                        fieldUrl='/v3/patient/search'
                        onBlur={event => handlePatientFieldBlur(event, props)}
                        readOnly
                      />
                      <TextInput
                        parentClass='col-span-12 md:col-span-6 lg:col-span-2 xl:col-span-2'
                        readOnly
                        label={t('Speciality')}
                        placeholder={t('Speciality')}
                        name='speciality'
                      />
                      <DropdownField
                        parentClass='col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4'
                        label={t('SelectPayer')}
                        placeholder={t('SelectPayer')}
                        name='payerName'
                        optionLabel='label'
                        optionValue='value'
                        options={
                          props.values.patientType == 'cash'
                            ? patientCashPlansOptionsFormat(cashPayers)
                            : patientInsuracnePlansOptionsFormat(
                              patientInsuracnePlans
                            )
                        }
                        onChange={event => {
                          let value = event?.target?.value
                          if (props?.values?.patientType == 'cash') {
                            let payerData = cashPayers?.find(
                              data => data?.payer_id == value
                            )
                            props.setFieldValue('payerName', value)
                            props.setFieldValue('items', [])
                            setSelectedPayerData(payerData)
                          } else {
                            let payerData = patientInsuracnePlans?.find(
                              data => data?.his_payer_id == value
                            )
                            props.setFieldValue('payerName', value)
                            props.setFieldValue('items', [])
                            setSelectedPayerData(payerData)
                          }
                        }}
                      />
                      <DropdownField
                        loading={fieldsLoading}
                        parentClass='col-span-12 md:col-span-6 lg:col-span-2 xl:col-span-2'
                        label={t('SelectPractitioner')}
                        placeholder={t('SelectPractitioner')}
                        name='practitioner'
                        filter
                        options={practionerOptionsFormat(practitionersList)}
                        disabled
                      />
                      <DropdownField
                        parentClass='col-span-12 md:col-span-6 lg:col-span-2 xl:col-span-2'
                        label={t('VisitType')}
                        placeholder={t('SelectVisitType')}
                        name='visitType'
                        options={visitTypeOptions(t)}
                        onChange={event => {
                          let value = event?.target?.value
                          props.setFieldValue('visitType', value)
                          if (value == 'Follow Up') {
                            props.setFieldValue('items', [])
                          }
                        }}
                      />
                      <DropdownField
                        parentClass='col-span-12 md:col-span-6 lg:col-span-2 xl:col-span-2'
                        label={t('PaymentMethod')}
                        placeholder={t('SelectPaymentMethod')}
                        name='paymentMethod'
                        options={[
                          ...paymentMethods(t),
                          ...[
                            {
                              label: t('Deposit'),
                              value: 'Deposit'
                            }
                          ]
                        ]}
                        onChange={e => {
                          const method = e.value
                          const currentCardKey = props.values.cardType || 'Mada'

                          props.setFieldValue('paymentMethod', method)
                          if (method === 'card') {
                            props.setValues(prev => ({
                              ...prev,
                              paymentMethod: method,
                              cardType: currentCardKey,
                              cash: null,
                              bank: null
                            }))
                          } else if (method === 'multi_payment') {
                            props.setValues(prev => ({
                              ...prev,
                              paymentMethod: method,
                              cardType: prev.cardType || 'Mada',
                              cash: prev.cash ?? 0,
                              bank: prev.bank ?? 0,
                              credit: prev.credit ?? 0,
                              [currentCardKey]: prev[currentCardKey] ?? 0,
                              cards:
                                prev.cards && prev.cards.length > 0
                                  ? prev.cards
                                  : [{ cardType: 'Mada', amount: 0 }]
                            }))
                          } else {
                            props.setValues(prev => ({
                              ...prev,
                              paymentMethod: method,
                              cardType: '',
                              cash: null,
                              bank: null,
                              [currentCardKey]: null
                            }))
                          }
                        }}
                      />
                      {(props?.values?.paymentMethod === 'card' ||
                        props?.values?.paymentMethod === 'multi_payment') && (
                          <DropdownField
                            parentClass='col-span-12 md:col-span-6 lg:col-span-2 xl:col-span-2'
                            label={
                              props?.values?.paymentMethod === 'multi_payment'
                                ? t('Add Card')
                                : t('Card Type')
                            }
                            placeholder={t('SelectCardType')}
                            name='cardType'
                            value={
                              props?.values?.paymentMethod === 'multi_payment'
                                ? null
                                : props.values.cardType
                            }
                            options={
                              props?.values?.paymentMethod === 'multi_payment'
                                ? cardOptions
                                  .map(group => ({
                                    ...group,
                                    options: group?.options?.filter(
                                      opt =>
                                        !props.values.cards?.some(
                                          card => card.cardType === opt.value
                                        )
                                    )
                                  }))
                                  .filter(
                                    group =>
                                      group.options && group.options.length > 0
                                  )
                                : cardOptions
                            }
                            onChange={e => {
                              if (props.values.paymentMethod === 'multi_payment') {
                                if (e.value) {
                                  const newCards = [
                                    ...(props.values.cards || []),
                                    { cardType: e.value, amount: 0 }
                                  ]
                                  props.setFieldValue('cards', newCards)
                                  setTimeout(
                                    () => props.setFieldValue('cardType', null),
                                    0
                                  )
                                }
                              } else {
                                props.setFieldValue('cardType', e.value)
                              }
                            }}
                          />
                        )}
                      {props?.values?.paymentMethod === 'multi_payment' && (
                        <>
                          <TextInput
                            parentClass='col-span-12 md:col-span-6 lg:col-span-2 xl:col-span-2'
                            name='cash'
                            label={t('Cash')}
                            placeholder={t('EnterCashAmount')}
                            type='number'
                            step='any'
                          />
                          <TextInput
                            parentClass='col-span-12 md:col-span-6 lg:col-span-2 xl:col-span-2'
                            name='bank'
                            label={t('Bank')}
                            placeholder={t('EnterBankAmount')}
                            type='number'
                            step='any'
                          />
                          <TextInput
                            parentClass='col-span-12 md:col-span-6 lg:col-span-2 xl:col-span-2'
                            name='credit'
                            label={t('Credit')}
                            placeholder={t('EnterCreditAmount')}
                            type='number'
                            step='any'
                          />

                          {props.values.cards &&
                            props.values.cards.map((card, index) => (
                              <div
                                key={index}
                                className='col-span-12 md:col-span-6 lg:col-span-2 xl:col-span-2 flex items-end gap-2'
                              >
                                <div className='flex-1'>
                                  <TextInput
                                    name={`cards.${index}.amount`}
                                    label={
                                      cardLabels[card.cardType] || card.cardType
                                    }
                                    placeholder={t('Amount')}
                                    type='number'
                                    step='any'
                                  />
                                </div>
                                <div className='mb-1'>
                                  <button
                                    type='button'
                                    onClick={() => {
                                      const newCards = props.values.cards.filter(
                                        (_, i) => i !== index
                                      )
                                      props.setFieldValue('cards', newCards)
                                    }}
                                    className='text-red-500 hover:text-red-700 p-2 bg-red-50 hover:bg-red-100 rounded-md transition-colors'
                                    title={t('Remove')}
                                  >
                                    <FaTrash size={16} />
                                  </button>
                                </div>
                              </div>
                            ))}
                        </>
                      )}
                      {depositBalance > 0 && (
                        <SwitchInput
                          name='deduct_from_deposit'
                          value={props?.values?.deduct_from_deposit}
                          label={t('Deduct From Deposit')}
                          handleChange={e => {
                            props.setFieldValue('deduct_from_deposit', e.value)
                            if (e.value) {
                              props.setFieldValue('paymentMethod', 'Deposit')
                            } else {
                              props.setFieldValue('paymentMethod', 'card')
                              props.setFieldValue('cardType', 'Mada')
                              props.setFieldValue('cards', [])
                            }
                          }}
                          parentClass='col-span-12 md:col-span-6 justify-between lg:col-span-2 xl:col-span-2'
                        />
                      )}
                      {showComments && (
                        <TextInput
                          className='h-40'
                          parentClass='col-span-12'
                          label={t('Comment')}
                          placeholder={t('AddComment')}
                          name='comment'
                        />
                      )}
                    </div>
                  </div>

                  <div className='col-span-12 lg:col-span-1 flex gap-2'>
                    <div className='flex flex-col gap-2 w-fit'>
                      <CustomButton
                        className='!px-1.5'
                        buttonType='primary'
                        icon={<FaHistory size={17} />}
                        title={t('BillingHistory')}
                        onClick={() => {
                          if (selectedPatient) {
                            navigate(
                              `/patient-billing-history/${selectedPatient?.patient_id}`,
                              {
                                state: {
                                  selectedPatient: selectedPatient,
                                  backRoute: '/create-visit'
                                }
                              }
                            )
                          } else {
                            toast.error(
                              'Please select patient to view billing history'
                            )
                          }
                        }}
                      />
                      <CustomButton
                        className='!px-1.5'
                        buttonType='danger'
                        icon={<FaCreditCard size={17} />}
                        title={t('Pay Credit')}
                        onClick={() => {
                          if (selectedPatient) {
                            setOpenPayCreditForm(true)
                          } else {
                            toast.error('Please select patient to pay credit')
                          }
                        }}
                      />
                      <CustomButton
                        className='!px-1.5'
                        buttonType='success'
                        icon={<FaWallet size={17} />}
                        title={t('Add Deposit')}
                        onClick={() => {
                          if (selectedPatient) {
                            setOpenDepositForm(true)
                          } else {
                            toast.error('Please select patient to deposit')
                          }
                        }}
                      />
                    </div>

                    <div className='flex flex-col gap-2 w-fit'>
                      <CustomButton
                        className='!px-1.5'
                        buttonType='warning'
                        icon={<FaHandHoldingUsd size={17} />}
                        title={t('Withdraw Deposit')}
                        onClick={() => {
                          if (selectedPatient) {
                            setOpenWithdrawForm(true)
                          } else {
                            toast.error(
                              'Please select patient to withdraw deposit'
                            )
                          }
                        }}
                      />
                      <CustomButton
                        className='!px-1.5'
                        buttonType='secondary'
                        icon={<FaCommentAlt size={17} />}
                        title={t('Comments')}
                        onClick={() => {
                          setShowComments(prev => !prev)
                        }}
                      />
                      <CustomButton
                        type='button'
                        className='!px-1.5'
                        title={t('Apply Discount to All Items')}
                        icon={<RiDiscountPercentLine size={17} />}
                        buttonType='secondary'
                        onClick={() => {
                          const currentItems =
                            formRef?.current?.values?.items || []
                          if (currentItems.length === 0) {
                            toast.error(t('No items to apply discount'))
                            return
                          }
                          setOpenDiscountModal(true)
                        }}
                      />
                    </div>
                  </div>

                  {hasPermission('pricelists', 'get') && (
                    <div className='col-span-12 mt-2'>
                      <VisitPriceItemsPayBill
                        itemsLoading={itemsLoading}
                        setBillingVisitData={setBillingVisitData}
                        priceListType={priceListType}
                        activeIndex={activeIndex}
                        isAddCheckBox={isPayBill ? true : false}
                        formikRef={formRef}
                        formValues={formRef?.current?.values}
                        selectedPayerData={selectedPayerData}
                        selectedPatientData={selectedPatientData}
                        billingVisitData={billingVisitData}
                        department_id={
                          billingVisitData?.practitioner?.department?.id
                        }
                        isShowTitle={false}
                        isGroupedTable={isAllItemsMode}
                        getGroupTotal={getGroupPatientPayable}
                      />
                    </div>
                  )}
                </div>
                <div className='flex items-center justify-end mt-3 gap-3'>
                    <CustomButton
                      disabled={isLoading}
                      type='submit'
                      label={t('PayBill')}
                      loading={isLoading}
                      icon={<FaCheckDouble size={12} className='me-2' />}
                      buttonType='primary'
                    />
                </div>
              </Form>

              <ApplyDiscountModal
                isVisible={openDiscountModal}
                onClose={() => setOpenDiscountModal(false)}
                formikRef={formRef}
                setInvoiceDiscount={setInvoiceDiscount}
                departmentId={billingVisitData?.practitioner?.department?.id}
              />

              <PayBillInvoicesModal
                isVisible={invoicesModalOpen}
                onClose={handleCloseInvoicesModal}
                invoices={paidInvoices}
              />
            </div>
          )
        }}
      </Formik>
    </div>
  )
}

export default PayVisitBillForm
